/**
 * Replaces all occurrences of "skykick." and ".skykick" in the provided text, case-insensitively.
 * @param text The input text to process.
 * @param replacement The replacement string.
 * @returns The processed text with replacements applied.
 */
export function replaceSkyKick(text: string, replacement: string): string {
  if (!text) {
    return text;
  }

  // Regular expression to match "skykick." and ".skykick" case-insensitively
  const regex = /skykick\.|\.\skykick/gi;

  return text.replace(regex, replacement);
}
